import { OrderType, SLHeaders } from '@travelwin/core';

import { request as authorizedRequests } from '../helpers/authorizedRequests';

const baseUri = 'ecommerce';

export interface UserUpdateRequest {
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  promo_opt_in?: boolean;
  referred_by?: string;
  locale?: string;
}

export const registerContact = ({
  sessionId,
  visitorOrigin,
}: {
  sessionId: string;
  visitorOrigin?: string;
}): Promise<OrderType> => {
  const options = {
    method: 'POST',
    headers: {
      [SLHeaders.SESSION_ID]: sessionId,
      ...(visitorOrigin ? { [SLHeaders.VISITOR_ORIGIN]: visitorOrigin } : {}),
    },
  };
  return authorizedRequests(`${baseUri}/users`, options);
};

export const updateUser = ({
  user,
  sessionId,
  jwtToken,
  visitorOrigin,
}: {
  user: UserUpdateRequest;
  sessionId: string;
  jwtToken?: string;
  visitorOrigin?: string;
}) => {
  const options = {
    method: 'PATCH',
    headers: {
      [SLHeaders.SESSION_ID]: sessionId,
      ...(visitorOrigin ? { [SLHeaders.VISITOR_ORIGIN]: visitorOrigin } : {}),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  };

  return authorizedRequests(`${baseUri}/users`, options, jwtToken);
};

export const deleteUser = ({
  sessionId,
  visitorOrigin,
}: {
  sessionId: string;
  visitorOrigin?: string;
}) => {
  const options = {
    method: 'DELETE',
    headers: {
      [SLHeaders.SESSION_ID]: sessionId,
      ...(visitorOrigin ? { [SLHeaders.VISITOR_ORIGIN]: visitorOrigin } : {}),
    },
  };

  const path = 'ecommerce/users';

  return authorizedRequests(path, options);
};
